import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from '@/router/routes';
import store from '@/store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition)
      return savedPosition
    return { x: 0, y: 0 };
  },
});

const nextFactory = async (context, middleware, index) => {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware)
    return context.next;
  return async (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = await nextFactory(context, middleware, index + 1);
    await subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach(async (to, from, next) => {
  if (to.meta.middlewares) {
    const middleware = to.meta.middlewares;
    const context = { from, next, router, to, };
    const nextMiddleware = await nextFactory(context, middleware, 1);
    await middleware[0]({ ...context, next: nextMiddleware });
  }
  next();
});

// Send SPA pageviews to analytics on route changes
router.afterEach((to) => {
  try {
    if (typeof window !== 'undefined') {
      if (window._uxa) {
        window._uxa.push(['trackPageview', to.fullPath]);

        const account = store.state.account;
        if (account && account.id) {
          window._uxa.push(['trackDynamicVariable', {
            key: 'estado_cuenta',
            value: account.setupCompleted ? 'completa' : 'incompleta',
          }]);
          window._uxa.push(['trackDynamicVariable', {
            key: 'correo_usuario',
            value: account.email,
          }]);
        }
      }

      if (window.gtag) {
        window.gtag('config', 'G-59Z2ERD66X', { page_path: to.fullPath });
      } else if (window.dataLayer) {
        window.dataLayer.push({ event: 'pageview', page_path: to.fullPath });
      }
    }
  } catch (e) {
    // ignore errors in tracking
  }
});

export default router;
